import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { FlowModelFromXPage } from './FlowModelFromXPage';

const FlowModelFromXPageBridge = react2angular(FlowModelFromXPage, [
  'flowModelType',
  'creationType'
]);
export { FlowModelFromXPageBridge };
